import { Store } from 'src/store/index';

const getAbstractProduct = (store: Store) => store.design.abstractProduct;

export default getAbstractProduct;
